import { render, staticRenderFns } from "./GameSpeedH5.vue?vue&type=template&id=568eb348&scoped=true"
import script from "./GameSpeedH5.vue?vue&type=script&lang=js"
export * from "./GameSpeedH5.vue?vue&type=script&lang=js"
import style0 from "./GameSpeedH5.vue?vue&type=style&index=0&id=568eb348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568eb348",
  null
  
)

export default component.exports